import { configureStore } from "@reduxjs/toolkit";

// state
import auth from "./slices/auth";
import blog from "./slices/blog";
import navbar from "./slices/navbar";
import loading from "./slices/loading";
import company from "./slices/company";
import opportunity from "./slices/opportunity";
import training from "./slices/training";
import document from "./slices/document";
import notification from "./slices/notification";
import misc from "./slices/misc";
import service from "./slices/service";
import message from "./slices/message";
import serviveRequest from "./slices/request";
import locations from "./slices/locations";
import userProfile from "./slices/user-profile";
import compliance from "./slices/compliance";

export const store = configureStore({
  reducer: {
    auth,
    blog,
    misc,
    navbar,
    loading,
    message,
    company,
    service,
    training,
    document,
    opportunity,
    notification,
    serviveRequest,
    locations,
    userProfile,
    compliance,
  },
  devTools: process.env.NODE_ENV === "production" ? false : true,
});

if (typeof window !== "undefined") {
  window.localStorage.removeItem("@user");
}

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
